import { useAuthContext } from '@trufla-technology/trufla-trudomain/dist/lib';
import { DateTime } from 'luxon';

export const useReadableDateTime = () => {
  const authContext = useAuthContext();
  // @ts-ignore - keycloak user info type is empty object
  const dateFormat = authContext.keycloak?.userInfo?.datetimeFormat;
  // @ts-ignore - keycloak user info type is empty object
  const locale = authContext.keycloak?.userInfo?.locale;
  // @ts-ignore - keycloak user info type is empty object
  const timezone = authContext.keycloak?.userInfo?.timeZone;

  return (date: string, format?: string) =>
    DateTime.fromISO(date)
      .setLocale(locale || 'en-CA')
      .setZone(timezone || 'America/Edmonton')
      .toLocal()
      .toFormat(format || dateFormat || 'LLL dd, yyyy - hh:mma');
};
